// extracted by mini-css-extract-plugin
export default {"section":"CarBasicInfo_section__JxAoJ","header":"CarBasicInfo_header__kNmmo","grid":"CarBasicInfo_grid__aOQEF"};